module.exports = __webpack_public_path__ + "media/images/icons/zoom-in-ec8b055974238072a8ae3f6b8935d876.svg";